export const SET_INVOICE_LINE_FILTER_VALUE = 'SET_INVOICE_LINE_FILTER_VALUE';
export const EXPAND_INVOICE_LINE_FILTER = 'EXPAND_INVOICE_LINE_FILTER';
export const APPLY_INVOICE_LINE_FILTERS = 'APPLY_INVOICE_LINE_FILTERS';
export const RESTORE_INVOICE_LINE_FILTERS = 'RESTORE_INVOICE_LINE_FILTERS';
export const CLEAR_ALL_INVOICE_LINE_FILTERS = 'CLEAR_ALL_INVOICE_LINE_FILTERS';
export const CLEAR_INVOICE_LINE_FILTER = 'CLEAR_INVOICE_LINE_FILTER';


// WEBPACK FOOTER //
// ./src/redux/invoiceLinesFilters/InvoiceLinesFiltersConstants.js